import { render, staticRenderFns } from "./PRLevel.vue?vue&type=template&id=052618a2&scoped=true&"
import script from "./PRLevel.vue?vue&type=script&lang=js&"
export * from "./PRLevel.vue?vue&type=script&lang=js&"
import style0 from "./PRLevel.vue?vue&type=style&index=0&id=052618a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052618a2",
  null
  
)

export default component.exports